import { createImmerReducer } from "utils/ReducerUtils";
import type { ReduxAction } from "actions/ReduxActionTypes";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export interface AIChatState {
  isProcessing: boolean;
  runId: string;
  threadId: string;
  isWaitingForResponse: boolean;
  isThreadLoading: boolean;
  isCancelling: boolean;
}

export interface AIChatReduxState {
  [widgetId: string]: AIChatState;
}

export const initialAIChatState: AIChatState = {
  isProcessing: false,
  runId: "",
  threadId: "",
  isWaitingForResponse: false,
  isThreadLoading: false,
  isCancelling: false,
};

export const initialState: AIChatReduxState = {};

export const aiChatHandlers = {
  [ReduxActionTypes.AI_CHAT_SET_STATE]: (
    draft: AIChatReduxState,
    action: ReduxAction<{ widgetId: string; state: Partial<AIChatState> }>,
  ) => {
    const { state, widgetId } = action.payload;

    draft[widgetId] = { ...draft[widgetId], ...state };

    return draft;
  },
  [ReduxActionTypes.AI_CHAT_RESET_STATE]: (
    draft: AIChatReduxState,
    action: ReduxAction<{ widgetId: string }>,
  ) => {
    draft[action.payload.widgetId] = { ...initialAIChatState };

    return draft;
  },
  [ReduxActionTypes.AI_CHAT_REMOVE_WIDGET]: (
    draft: AIChatReduxState,
    action: ReduxAction<{ widgetId: string }>,
  ) => {
    delete draft[action.payload.widgetId];

    return draft;
  },
};

const aiChatReducer = createImmerReducer(initialState, aiChatHandlers);

export default aiChatReducer;
